module.exports = __webpack_public_path__ + "img/201.55ff3b5e.png";